'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _UIAbstractPopup = require('./UIAbstractPopup');

var _UIAbstractPopup2 = _interopRequireDefault(_UIAbstractPopup);

var _UIPopoverContent = require('./UIPopoverContent');

var _UIPopoverContent2 = _interopRequireDefault(_UIPopoverContent);

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _PlacementConstants = require('./PlacementConstants');

var _EventHandlers = require('../core/EventHandlers');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Placement = require('./utils/Placement');

var _domElement = require('../utils/propTypes/domElement');

var _domElement2 = _interopRequireDefault(_domElement);

var _ModalTransitionContext = require('../context/ModalTransitionContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getArrowSize = function getArrowSize(arrowSize, use) {
  if (arrowSize != null) return arrowSize;
  if (use === 'tooltip' || use === 'tooltip-danger') return 'small';
  return 'medium';
};

var getAnimateOnToggle = function getAnimateOnToggle(animateOnToggle, computedArrowSize) {
  return animateOnToggle != null ? animateOnToggle : computedArrowSize !== 'none';
};

var getPlacement = function getPlacement(placementProp, placementState) {
  return placementState || placementProp;
};

var UIPopover = function (_PureComponent) {
  _inherits(UIPopover, _PureComponent);

  function UIPopover(props) {
    _classCallCheck(this, UIPopover);

    var _this = _possibleConstructorReturn(this, (UIPopover.__proto__ || Object.getPrototypeOf(UIPopover)).call(this, props));

    _this.state = {
      closeComplete: true,
      placement: null
    };

    _this.handleWindowClick = _this.handleWindowClick.bind(_this);
    _this.handleTetherUpdate = _this.handleTetherUpdate.bind(_this);
    _this.handleCloseComplete = _this.handleCloseComplete.bind(_this);
    _this.reposition = _this.reposition.bind(_this);
    return _this;
  }

  _createClass(UIPopover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;
      if (this.props.open) {
        // Delay binding to ensure that the click that opened the popover is ignored
        this._mountFrame = requestAnimationFrame(function () {
          window.addEventListener('click', _this2.handleWindowClick);
          _this2.startIntersectionObserver();
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // If the placement prop is reset, clear our internal override.
      if (nextProps.placement !== this.props.placement) {
        this.setState({ placement: null });
      }

      // If a close transition is starting, update the closeComplete state.
      if (!nextProps.open && this.props.open && this.state.closeComplete) {
        this.setState({ closeComplete: false });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var open = this.props.open;

      if (open && !prevProps.open) {
        window.addEventListener('click', this.handleWindowClick);
        this.startIntersectionObserver();
      } else if (!open && prevProps.open) {
        window.removeEventListener('click', this.handleWindowClick);
        this.stopIntersectionObserver();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      window.removeEventListener('click', this.handleWindowClick);
      this.stopIntersectionObserver();
      cancelAnimationFrame(this._mountFrame);
      clearTimeout(this._leaveTransitionTimeout);
    }
  }, {
    key: 'startIntersectionObserver',
    value: function startIntersectionObserver() {
      var _props = this.props,
          closeOnTargetLeave = _props.closeOnTargetLeave,
          onOpenChange = _props.onOpenChange;

      // When closeOnTargetLeave is enabled, we use an IntersectionObserver to close the popover if
      // its target leaves the screen due to scrolling (#3856).

      if (!closeOnTargetLeave) return;

      var _window = window,
          IntersectionObserver = _window.IntersectionObserver;

      if (!IntersectionObserver) return; // No browser support (IE11)

      var targetEl = (0, _reactDom.findDOMNode)(this);
      if (!targetEl) return;

      this._intersectionObserver = new IntersectionObserver(function (entries) {
        var intersectionRatio = entries[0].intersectionRatio;

        if (intersectionRatio <= 0 && onOpenChange) {
          onOpenChange((0, _SyntheticEvent2.default)(false));
        }
      });
      this._intersectionObserver.observe(targetEl);
    }
  }, {
    key: 'stopIntersectionObserver',
    value: function stopIntersectionObserver() {
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
        this._intersectionObserver = null;
      }
    }
  }, {
    key: 'handleWindowClick',
    value: function handleWindowClick(evt) {
      var _props2 = this.props,
          closeOnOutsideClick = _props2.closeOnOutsideClick,
          onOpenChange = _props2.onOpenChange,
          shouldCloseOnClick = _props2.shouldCloseOnClick,
          target = _props2.target;


      if (shouldCloseOnClick) {
        var shouldClose = shouldCloseOnClick(evt);
        if (shouldClose != null) {
          if (shouldClose && onOpenChange) onOpenChange((0, _SyntheticEvent2.default)(false));
          return;
        }
      }

      if (!closeOnOutsideClick || !this._isMounted) return;

      var clickTarget = evt.target;
      var tetherTarget = target || (0, _reactDom.findDOMNode)(this._popup);
      var contentEl = (0, _reactDom.findDOMNode)(this._content);

      // Ignore the click if it's within our Tether target
      if (tetherTarget && tetherTarget.contains(clickTarget)) return;

      // Ignore the click if it's within our popover container
      if (contentEl && (0, _EventHandlers.isClickWithinContainer)(evt, contentEl)) return;

      // Otherwise, trigger close
      if (onOpenChange) onOpenChange((0, _SyntheticEvent2.default)(false));
    }
  }, {
    key: 'handleTetherUpdate',
    value: function handleTetherUpdate(event) {
      // Adjust our placement state to reflect Tether's response to a constraint
      var _props3 = this.props,
          autoPlacement = _props3.autoPlacement,
          onChangePlacement = _props3.onChangePlacement,
          placementProp = _props3.placement;
      var placementState = this.state.placement;

      var oldPlacement = getPlacement(placementProp, placementState);

      var newPlacementVert = autoPlacement === 'horiz' ? (0, _Placement.getVertPart)(oldPlacement) : event.targetAttachment.top;
      var newPlacementHoriz = autoPlacement === 'vert' ? (0, _Placement.getHorizPart)(oldPlacement) : event.targetAttachment.left;

      if (!newPlacementVert || !newPlacementHoriz) {
        // This indicates pinning, which we don't need to respond to
        return;
      }

      var newPlacement = null;
      if (newPlacementVert === 'center' || newPlacementVert === 'middle') {
        newPlacement = newPlacementHoriz;
      } else if (newPlacementHoriz === 'center' || newPlacementHoriz === 'middle') {
        // #1942
        newPlacement = newPlacementVert;
      } else {
        newPlacement = newPlacementVert + ' ' + newPlacementHoriz;
      }

      if (this.state.placement !== newPlacement) {
        this.setState({
          placement: newPlacement
        });
        if (onChangePlacement) onChangePlacement({ newPlacement: newPlacement });
      }
    }
  }, {
    key: 'handleCloseComplete',
    value: function handleCloseComplete() {
      var onCloseComplete = this.props.onCloseComplete;

      if (onCloseComplete) onCloseComplete();
      if (this._isMounted) {
        this.setState({ closeComplete: true });
      }
    }
  }, {
    key: 'reposition',
    value: function reposition() {
      if (this._popup) {
        this._popup.repositionTether();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props4 = this.props,
          addTargetClasses = _props4.addTargetClasses,
          animateOnMount = _props4.animateOnMount,
          animateOnToggle = _props4.animateOnToggle,
          arrowSize = _props4.arrowSize,
          autoPlacement = _props4.autoPlacement,
          children = _props4.children,
          className = _props4.className,
          __closeOnOutsideClick = _props4.closeOnOutsideClick,
          __closeOnTargetLeave = _props4.closeOnTargetLeave,
          onFocusLeave = _props4.onFocusLeave,
          __onChangePlacement = _props4.onChangePlacement,
          onOpenChange = _props4.onOpenChange,
          __onCloseComplete = _props4.onCloseComplete,
          open = _props4.open,
          pinToConstraint = _props4.pinToConstraint,
          pinToOutOfBoundsTarget = _props4.pinToOutOfBoundsTarget,
          placementProp = _props4.placement,
          __shouldCloseOnClick = _props4.shouldCloseOnClick,
          target = _props4.target,
          targetAttachment = _props4.targetAttachment,
          use = _props4.use,
          zIndex = _props4.zIndex,
          _bodyElement = _props4._bodyElement,
          _distanceAdjustment = _props4._distanceAdjustment,
          _insetAdjustment = _props4._insetAdjustment,
          _useMutationObserver = _props4._useMutationObserver,
          rest = _objectWithoutProperties(_props4, ['addTargetClasses', 'animateOnMount', 'animateOnToggle', 'arrowSize', 'autoPlacement', 'children', 'className', 'closeOnOutsideClick', 'closeOnTargetLeave', 'onFocusLeave', 'onChangePlacement', 'onOpenChange', 'onCloseComplete', 'open', 'pinToConstraint', 'pinToOutOfBoundsTarget', 'placement', 'shouldCloseOnClick', 'target', 'targetAttachment', 'use', 'zIndex', '_bodyElement', '_distanceAdjustment', '_insetAdjustment', '_useMutationObserver']);

      var _state = this.state,
          closeComplete = _state.closeComplete,
          placementState = _state.placement;


      return _react2.default.createElement(
        _ModalTransitionContext.ModalTransitionContextConsumer,
        null,
        function (_ref) {
          var inModalTransition = _ref.transitioning;

          // `contentOpen` triggers open/close transitions
          var contentOpen = open && !inModalTransition;
          // `tetherOpen` determines whether the popover is in the DOM
          var tetherOpen = contentOpen || !closeComplete;

          // Perf: Don't generate props for the tether if we're closed.
          var popupProps = null;
          if (tetherOpen) {
            var computedArrowSize = getArrowSize(arrowSize, use);
            var computedAnimateOnToggle = getAnimateOnToggle(animateOnToggle, computedArrowSize);
            var computedArrowParams = _UIPopoverArrow2.default.ARROW_SIZES[computedArrowSize];

            var computedPlacement = getPlacement(placementProp, placementState);

            var renderedContent = tetherOpen ? _react2.default.createElement(_UIPopoverContent2.default, _extends({}, rest, {
              animateOnMount: Boolean(animateOnMount && !_this3._isMounted || computedAnimateOnToggle && _this3._isMounted),
              animateOnToggle: computedAnimateOnToggle,
              arrowSize: computedArrowSize,
              className: className,
              'data-component-name': 'UIPopover',
              onCloseComplete: _this3.handleCloseComplete,
              open: contentOpen,
              placement: computedPlacement,
              ref: function ref(_ref2) {
                _this3._content = _ref2;
              },
              use: use,
              onOpenChange: onOpenChange
            })) : null;

            popupProps = {
              addTargetClasses: addTargetClasses,
              autoPlacement: autoPlacement,
              bodyElement: _bodyElement,
              center: computedArrowSize !== 'none',
              content: renderedContent,
              distance: computedArrowParams.distance + _distanceAdjustment,
              inset: computedArrowParams.inset + _insetAdjustment,
              onFocusLeave: onFocusLeave,
              onTetherUpdate: _this3.handleTetherUpdate,
              open: tetherOpen,
              pinToConstraint: pinToConstraint,
              pinToOutOfBoundsTarget: pinToOutOfBoundsTarget,
              placement: computedPlacement,
              ref: function ref(_ref3) {
                _this3._popup = _ref3;
              },
              target: target,
              targetAttachment: targetAttachment,
              zIndex: zIndex,
              _useMutationObserver: _useMutationObserver
            };
          }

          return _react2.default.createElement(
            _UIAbstractPopup2.default,
            popupProps,
            children
          );
        }
      );
    }
  }]);

  return UIPopover;
}(_react.PureComponent);

UIPopover.propTypes = _extends({}, _UIPopoverContent2.default.propTypes, {
  addTargetClasses: _react.PropTypes.bool,
  arrowSize: _react.PropTypes.oneOf(Object.keys(_UIPopoverArrow2.default.ARROW_SIZES)),
  autoPlacement: _UIAbstractPopup2.default.propTypes.autoPlacement,
  children: _react.PropTypes.element,
  closeOnOutsideClick: _react.PropTypes.bool.isRequired,
  closeOnTargetLeave: _react.PropTypes.bool.isRequired,
  onFocusLeave: _react.PropTypes.func,
  onChangePlacement: _react.PropTypes.func,
  onOpenChange: _react.PropTypes.func,
  pinToConstraint: _UIAbstractPopup2.default.propTypes.pinToConstraint,
  pinToOutOfBoundsTarget: _UIAbstractPopup2.default.propTypes.pinToOutOfBoundsTarget,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  shouldCloseOnClick: _react.PropTypes.func,
  target: _domElement2.default,
  targetAttachment: _react.PropTypes.string.isRequired,
  zIndex: _react.PropTypes.number.isRequired,
  _distanceAdjustment: _react.PropTypes.number,
  _insetAdjustment: _react.PropTypes.number,
  _bodyElement: _domElement2.default,
  _useMutationObserver: _react.PropTypes.bool.isRequired
});

UIPopover.defaultProps = _extends({}, _UIPopoverContent2.default.defaultProps, {
  autoPlacement: true,
  closeOnOutsideClick: true,
  closeOnTargetLeave: false,
  _distanceAdjustment: 0,
  _insetAdjustment: 0,
  pinToConstraint: ['top', 'bottom'],
  pinToOutOfBoundsTarget: false,
  targetAttachment: 'auto',
  zIndex: _UIAbstractPopup2.default.defaultProps.zIndex,
  _useMutationObserver: false
});

UIPopover.displayName = 'UIPopover';

var UIControlledPopover = UIPopover;
exports.default = UIControlledPopover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/tooltip/UIControlledPopover.js
// module id = 167
// module chunks = 3 4 5